import { useTranslation } from "react-i18next";
import { Field } from "../../../../components/shared/Form";
import SwitchNumberInput from "../components/SwitchNumberInput";

function OpenShift() {
    const { t } = useTranslation();
    return (
        <div className="tw-p-5 tw-flex tw-flex-col tw-gap-1">
            <Field
                className="tw-mb-3"
                name="openShift.coverageDeadline"
                shouldUnregister={false}
            >
                <SwitchNumberInput label={t("coverage-deadline")} unit="hours" />
            </Field>
        </div>
    );
}

export default OpenShift;
